import { formatCurrency, formatDateTime } from "../../../utils/formatters";
import Badge from "../../common/Badge";
import { TrendingUp, TrendingDown } from "lucide-react";

const descriptionLabel = (desc) => {
  switch (desc) {
    case "TicketSale":
      return "Ticket Sale";
    case "PaymentGatewayFee":
      return "PG Fee";
    case "Payout":
      return "Payout";
    case "WalletTopUp":
      return "Wallet Top-Up";
    case "Commission":
      return "Commission";
    default:
      return desc;
  }
};

const descriptionVariant = (desc) => {
  switch (desc) {
    case "TicketSale":
      return "info";
    case "Payout":
      return "danger";
    case "Commission":
      return "warning";
    case "WalletTopUp":
      return "success";
    default:
      return "default";
  }
};

const TransactionsTable = ({ transactions, loading }) => (
  <div className="bg-bg-surface border border-border rounded-xl overflow-hidden">
    <div className="px-5 py-4 border-b border-border">
      <h3 className="text-sm font-semibold text-text-primary">
        Transaction History
      </h3>
    </div>
    <table className="w-full text-sm">
      <thead className="bg-bg-elevated text-text-muted text-xs uppercase">
        <tr>
          <th className="px-5 py-3 text-left">Description</th>
          <th className="px-5 py-3 text-left">Type</th>
          <th className="px-5 py-3 text-left">Reference</th>
          <th className="px-5 py-3 text-left">Amount</th>
          <th className="px-5 py-3 text-left">Balance After</th>
          <th className="px-5 py-3 text-left">Date</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-border">
        {loading ? (
          Array.from({ length: 8 }).map((_, i) => (
            <tr key={i} className="animate-pulse">
              {Array.from({ length: 6 }).map((_, j) => (
                <td key={j} className="px-5 py-3">
                  <div className="h-4 bg-bg-elevated rounded w-24" />
                </td>
              ))}
            </tr>
          ))
        ) : transactions.length === 0 ? (
          <tr>
            <td
              colSpan={6}
              className="px-5 py-12 text-center text-xs text-text-muted"
            >
              No transactions found
            </td>
          </tr>
        ) : (
          transactions.map((tx) => (
            <tr key={tx.id} className="hover:bg-bg-elevated transition">
              {/* Description */}
              <td className="px-5 py-3">
                <p className="text-text-primary font-medium text-sm">
                  {tx.name}
                </p>
                <Badge
                  label={descriptionLabel(tx.transactionDescription)}
                  variant={descriptionVariant(tx.transactionDescription)}
                />
              </td>

              {/* Type */}
              <td className="px-5 py-3">
                <div
                  className={`flex items-center gap-1.5 text-xs font-medium ${
                    tx.transactionType === "Credit"
                      ? "text-green-400"
                      : "text-red-400"
                  }`}
                >
                  {tx.transactionType === "Credit" ? (
                    <TrendingUp size={13} />
                  ) : (
                    <TrendingDown size={13} />
                  )}
                  {tx.transactionType}
                </div>
              </td>

              {/* Reference */}
              <td className="px-5 py-3">
                {tx.reference ? (
                  <code className="text-xs bg-bg-elevated px-2 py-0.5 rounded text-text-muted">
                    {tx.reference}
                  </code>
                ) : (
                  <span className="text-text-hint text-xs">—</span>
                )}
              </td>

              {/* Amount */}
              <td className="px-5 py-3">
                <span
                  className={`text-sm font-semibold ${
                    tx.transactionType === "Credit"
                      ? "text-green-400"
                      : "text-red-400"
                  }`}
                >
                  {tx.transactionType === "Credit" ? "+" : "-"}
                  {formatCurrency(tx.amount)}
                </span>
              </td>

              {/* Balance after */}
              <td className="px-5 py-3 text-text-secondary text-sm font-medium">
                {formatCurrency(tx.balance)}
              </td>

              {/* Date */}
              <td className="px-5 py-3 text-text-muted text-xs">
                {formatDateTime(tx.createdAt)}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default TransactionsTable;
